import axios from "axios";
import React, { useEffect, useLayoutEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Link, useHistory, useLocation } from "react-router-dom";
import "./WithdrawHistory.css";
import { staffIsAdmin } from "../../utils/staffIsAdmin";
import {
  withdrawPayoutAmount,
  withdrawCashbackHint,
  hasWithdrawCashback,
} from "../../utils/withdrawCashbackDisplay";
import WithdrawFailReasonFields from "./WithdrawFailReasonFields";

const tabFromSearch = (search) => {
    const raw = new URLSearchParams(search || "").get("tab");
    if (raw === "pending") return "pending";
    if (raw === "success") return "success";
    if (raw === "failed") return "failed";
    return "all";
};

const SucWithdraw = () => {
    const history = useHistory();
    const location = useLocation();
    const [user, setUser] = useState([]);
    const [listLoading, setListLoading] = useState(true);
    const [copiedUpiId, setCopiedUpiId] = useState(null);
    const [confirmAction, setConfirmAction] = useState({ show: false, type: '', withdraw: null });
    const [failReason, setFailReason] = useState('');
    const [failNote, setFailNote] = useState('');
    const canDeleteFailedLog = staffIsAdmin();
    
    const backendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const backendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    let baseUrl = nodeMode === "development" ? backendLocalApiUrl : backendLiveApiUrl;

    let [limit, setLimit] = useState(10);
    const [pageNumber, setPageNumber] = useState(0);
    const [numberOfPages, setNumberOfPages] = useState(0);
    const [searchList, setSearchList] = useState("");
    const [searchType, setSearchType] = useState("0");
    /** From URL ?tab= — all | pending | success | failed */
    const statusTab = tabFromSearch(location.search);

    const statusParamForApi = (tab) => {
        if (tab === "all") return null;
        if (tab === "pending") return "Pending,pending,none";
        if (tab === "success") return "SUCCESS";
        return "FAILED,reject";
    };

    const copyToClipboard = (text, id) => {
        navigator.clipboard.writeText(text);
        setCopiedUpiId(id);
        setTimeout(() => setCopiedUpiId(null), 2000);
    };

    const setpageLimit = (event) => {
        setLimit(event.target.value);
    }

    const handlePageClick = async (data) => {
        let currentPage = data.selected + 1;
        setPageNumber(currentPage);
    };

    const searchHandler = (event) => {
        setSearchList(event.target.value);
    }

    const fetchWithdrawals = () => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        
        const st = statusParamForApi(statusTab);
        let url = `txn/withdraw/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}`;
        if (st != null && st !== "") {
            url += `&_status=${encodeURIComponent(st)}`;
        }
        
        setListLoading(true);
        axios.get(baseUrl + url, { headers })
            .then((res) => {
                setUser(res.data.data || []);
                setNumberOfPages(res.data.totalPages || 0);
            })
            .catch((e) => {
                console.error("Error fetching withdrawals:", e);
            })
            .finally(() => setListLoading(false));
    }

    const resetConfirmModal = () => {
        setConfirmAction({ show: false, type: '', withdraw: null });
        setFailReason('');
        setFailNote('');
    };

    const handleConfirmAction = (type, withdraw) => {
        setFailReason('');
        setFailNote('');
        setConfirmAction({
            show: true,
            type: type,
            withdraw: withdraw
        });
    }

    const executeAction = () => {
        if (!confirmAction.withdraw) return;

        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }

        let status = '';
        if (confirmAction.type === 'success') {
            status = 'SUCCESS';
        } else if (confirmAction.type === 'failed') {
            status = 'FAILED';
        } else if (confirmAction.type === 'check') {
            checkPayout(confirmAction.withdraw);
            resetConfirmModal();
            return;
        }

        if (status === 'FAILED') {
            if (!failReason) {
                alert('Please select a reason — user will see it in the app.');
                return;
            }
            if (failReason === 'other' && !failNote.trim()) {
                alert('Please enter a note for Other reason.');
                return;
            }
        }

        const body = {
            status,
            ...(status === 'FAILED'
                ? {
                    failReason,
                    txn_msg: failReason === 'other' ? failNote.trim() : undefined,
                }
                : {}),
        };

        axios.post(baseUrl + `userwithdrawupdate/${confirmAction.withdraw._id}`, body, { headers })
            .then((res) => {
                fetchWithdrawals();
                resetConfirmModal();
            })
            .catch((e) => {
                const msg = e.response?.data?.message || e.message || 'Update failed';
                alert(msg);
                console.error("Error updating status:", e);
                resetConfirmModal();
            })
    }

    const deleteFailedWithdraw = (row) => {
        if (String(row.status || '').toLowerCase() !== 'failed') return;
        if (!window.confirm('Sirf FAILED withdrawal ki history delete? Balance / refund kuch nahi badlega.')) return;
        const access_token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${access_token}` };
        axios.delete(baseUrl + `admin/txn/withdraw-failed/${row._id}`, { headers })
            .then(() => fetchWithdrawals())
            .catch((e) => {
                alert(e.response?.data?.msg || e.message || 'Delete failed');
            });
    };

    const checkPayout = (withdraw) => {
        const { payment_gatway, _id: txn_id, referenceId } = withdraw;
        
        if (!referenceId) {
            return;
        }

        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }

        let endpoint = '';
        if (payment_gatway === 'razorpay') {
            endpoint = 'razorpaypayoutscheck/response';
        } else if (payment_gatway === 'decentro') {
            endpoint = 'decentropayout/response';
        } else {
            return;
        }

        axios.post(baseUrl + endpoint, { txn_id, referenceId }, { headers })
            .then((res) => {
                fetchWithdrawals();
            })
            .catch((e) => {
                console.error("Error checking payout:", e);
            })
    }

    const dateFormat = (e) => {
        const date = new Date(e);
        return date.toLocaleString('default', { 
            month: 'short', 
            day: 'numeric', 
            hour: '2-digit', 
            minute: '2-digit',
            hour12: true 
        });
    }

    const formatPhoneForWhatsApp = (phone) => {
        if (!phone) return '';
        const phoneStr = String(phone);
        const digits = phoneStr.replace(/\D/g, '');
        if (digits.length === 12) return digits;
        if (digits.length === 10) return `91${digits}`;
        return digits || '';
    };

    const getStatusBadge = (status, data) => {
        const statusLower = String(status || '').toLowerCase();
        const gameCreatedAt = new Date(data.createdAt).getTime();
        const canCheck = !['success', 'failed'].includes(statusLower) &&
            (gameCreatedAt + 7200000) < Date.now();
        const canUpdate = !['success', 'failed', 'reject'].includes(statusLower);

        const iconCheck = (
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <polyline points="20 6 9 17 4 12" />
            </svg>
        );
        const iconX = (
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
        );
        const iconSync = (
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                <path d="M3 3v5h5" />
                <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                <path d="M16 16h5v5" />
            </svg>
        );

        return (
            <div className="lp-wd-toolbar d-flex align-items-center flex-wrap">
                <div className="lp-wd-toolbar-badge">
                    {statusLower === 'success' ? (
                        <span className="badge badge-success px-2 py-1" style={{ fontSize: '11px' }}>SUCCESS</span>
                    ) : statusLower === 'failed' ? (
                        <span className="badge badge-danger px-2 py-1" style={{ fontSize: '11px' }}>FAILED</span>
                    ) : statusLower === 'pending' || statusLower === 'none' || statusLower === 'initiated' ? (
                        <span className="badge badge-warning px-2 py-1" style={{ fontSize: '11px' }}>PROCESSING</span>
                    ) : statusLower === 'reject' ? (
                        <span className="badge badge-secondary px-2 py-1" style={{ fontSize: '11px' }}>REJECTED</span>
                    ) : (
                        <span className="badge badge-info px-2 py-1" style={{ fontSize: '11px' }}>{status}</span>
                    )}
                </div>
                {canUpdate && (
                    <div className="lp-wd-toolbar-actions d-inline-flex flex-wrap align-items-center">
                        <button
                            type="button"
                            className="lp-wd-btn lp-wd-btn--approve"
                            onClick={() => handleConfirmAction('success', data)}
                            title="Mark as success"
                        >
                            {iconCheck}
                            <span>Approve</span>
                        </button>
                        <button
                            type="button"
                            className="lp-wd-btn lp-wd-btn--fail"
                            onClick={() => handleConfirmAction('failed', data)}
                            title="Mark as failed"
                        >
                            {iconX}
                            <span>Fail</span>
                        </button>
                    </div>
                )}
                {canCheck && data.referenceId && (
                    <button
                        type="button"
                        className="lp-wd-btn lp-wd-btn--sync"
                        onClick={() => handleConfirmAction('check', data)}
                        title="Check payout status"
                    >
                        {iconSync}
                        <span className="d-none d-lg-inline">Check</span>
                    </button>
                )}
                {canDeleteFailedLog && statusLower === 'failed' && (
                    <button
                        type="button"
                        className="lp-wd-btn lp-wd-btn--fail ml-1"
                        onClick={() => deleteFailedWithdraw(data)}
                        title="Remove failed record"
                    >
                        <span>Delete</span>
                    </button>
                )}
            </div>
        );
    }

    useLayoutEffect(() => {
        setPageNumber(0);
    }, [location.search]);

    useEffect(() => {
        fetchWithdrawals();
    }, [pageNumber, limit, searchList, searchType, location.search]);

    const onTabChange = (tab) => {
        history.replace({
            pathname: location.pathname,
            search: tab === "all" ? "" : `?tab=${tab}`,
        });
    };

    if (listLoading && user.length === 0) {
        return (
            <div className="d-flex justify-content-center align-items-center lp-withdraw-history" style={{ minHeight: '50vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    const rowSerial = (key) => key + 1 + (pageNumber * Number(limit));

    return (
        <>
            <div className="lp-withdraw-history">
                <div className="page-header">
                    <h4 className="mb-2 d-flex align-items-center gap-2" style={{ fontSize: '1.05rem', fontWeight: 700 }}>
                        <span className="text-primary" style={{ display: 'inline-flex', opacity: 0.9 }} aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                            </svg>
                        </span>
                        Withdrawal history
                    </h4>
                    <p className="page-subtitle mb-0 d-md-none">Compact list on small screens; desktop uses the full table below.</p>
                </div>

                <div className="admin-card">
                    <div className="lp-withdraw-tabs" role="tablist" aria-label="Withdrawal status">
                        <button
                            type="button"
                            role="tab"
                            aria-selected={statusTab === "all"}
                            className={"lp-withdraw-tab" + (statusTab === "all" ? " lp-withdraw-tab--active" : "")}
                            onClick={() => onTabChange("all")}
                        >
                            All
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={statusTab === "pending"}
                            className={"lp-withdraw-tab" + (statusTab === "pending" ? " lp-withdraw-tab--active" : "")}
                            onClick={() => onTabChange("pending")}
                        >
                            Pending
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={statusTab === "success"}
                            className={"lp-withdraw-tab" + (statusTab === "success" ? " lp-withdraw-tab--active" : "")}
                            onClick={() => onTabChange("success")}
                        >
                            Success
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={statusTab === "failed"}
                            className={"lp-withdraw-tab" + (statusTab === "failed" ? " lp-withdraw-tab--active" : "")}
                            onClick={() => onTabChange("failed")}
                        >
                            Failed
                        </button>
                    </div>
                    <div className="admin-card-header d-flex flex-wrap justify-content-between align-items-center" style={{ gap: '0.5rem' }}>
                        <span className="font-weight-bold">Filters</span>
                        <select
                            className="form-control form-control-sm"
                            style={{ maxWidth: '120px', minHeight: '40px' }}
                            value={limit}
                            onChange={setpageLimit}
                        >
                            <option value="10">10 / page</option>
                            <option value="20">20 / page</option>
                            <option value="50">50 / page</option>
                        </select>
                    </div>
                    <div className="card-body p-3">
                        <div className="lp-withdraw-filters">
                            <select
                                className="form-control form-control-sm lp-withdraw-filters-grow"
                                value={searchType}
                                onChange={(e) => setSearchType(e.target.value)}
                            >
                                <option value="0">Search by</option>
                                <option value="Name">Name</option>
                                <option value="Phone">Phone</option>
                            </select>
                            <input
                                type="text"
                                placeholder="Search…"
                                className="form-control form-control-sm lp-withdraw-filters-grow"
                                value={searchList}
                                onChange={searchHandler}
                            />
                        </div>

                        {user.length === 0 && !listLoading ? (
                            <div className="text-center py-5 text-muted">
                                <p className="mb-0">No records found.</p>
                            </div>
                        ) : null}

                        {user.length > 0 && (
                            <>
                            <div className="lp-withdraw-rows d-md-none">
                                {user.map((data, key) => {
                                    const whatsappPhone = formatPhoneForWhatsApp(data.User_id?.Phone);
                                    const displayPhone = data.User_id?.Phone ? `+91 ${data.User_id.Phone}` : '—';
                                    const upi = data.User_id?.upi_id || '';
                                    return (
                                        <div className="lp-withdraw-row lp-withdraw-row--3line" key={data._id}>
                                            <div className="lp-withdraw-row__line1">
                                                <span className="lp-withdraw-row__meta">#{rowSerial(key)} · {dateFormat(data.createdAt)}</span>
                                                <span className="lp-withdraw-row__amt" aria-label="Pay net" title={withdrawCashbackHint(data) || undefined}>
                                                  ₹{withdrawPayoutAmount(data).toLocaleString("en-IN")}
                                                </span>
                                            </div>
                                            {hasWithdrawCashback(data) && (
                                                <div className="lp-withdraw-row__cashback small text-muted px-1" style={{ lineHeight: 1.25 }}>
                                                    {withdrawCashbackHint(data)}
                                                </div>
                                            )}
                                            <div className="lp-withdraw-row__line2">
                                                <span className="lp-withdraw-row__user">
                                                    {data.User_id ? (
                                                        <Link to={`/user/view_user/${data.User_id._id}`}>{data.User_id.Name || 'User'}</Link>
                                                    ) : (
                                                        '—'
                                                    )}
                                                </span>
                                                {data.User_id?.Phone ? (
                                                    <a
                                                        href={`https://wa.me/${whatsappPhone}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="lp-withdraw-row__phone"
                                                    >
                                                        {displayPhone}
                                                    </a>
                                                ) : (
                                                    <span className="lp-withdraw-row__phone lp-withdraw-row__phone--muted">—</span>
                                                )}
                                                <span className="lp-withdraw-row__type-pill">{data.Withdraw_type || 'N/A'}</span>
                                            </div>
                                            <div className="lp-withdraw-row__line3">
                                                <div className="lp-withdraw-row__upi-block">
                                                    <span className="lp-withdraw-row__upi-label">UPI</span>
                                                    <span className="lp-withdraw-row__upi" title={upi || undefined}>
                                                        {upi || '—'}
                                                    </span>
                                                    {upi ? (
                                                        <button
                                                            type="button"
                                                            className="lp-withdraw-row__copy"
                                                            onClick={() => copyToClipboard(upi, `upi_${data._id}`)}
                                                        >
                                                            {copiedUpiId === `upi_${data._id}` ? 'Copied' : 'Copy'}
                                                        </button>
                                                    ) : null}
                                                </div>
                                                <div className="lp-withdraw-row__actions">{getStatusBadge(data.status, data)}</div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="table-responsive d-none d-md-block lp-withdraw-desktop-wrap">
                                <table className="table table-striped table-bordered table-hover mb-0 lp-withdraw-desktop-table">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Date &amp; time</th>
                                            <th>User</th>
                                            <th>Phone</th>
                                            <th>Type</th>
                                            <th>Pay (net)</th>
                                            <th>UPI ID</th>
                                            <th>Status &amp; actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {user.map((data, key) => {
                                            const whatsappPhone = formatPhoneForWhatsApp(data.User_id?.Phone);
                                            const displayPhone = data.User_id?.Phone ? `+91 ${data.User_id.Phone}` : '';
                                            return (
                                                <tr key={data._id} className="align-middle">
                                                    <td>{rowSerial(key)}</td>
                                                    <td>{dateFormat(data.createdAt)}</td>
                                                    <td>
                                                        {data.User_id && (
                                                            <Link to={`/user/view_user/${data.User_id._id}`}>
                                                                {data.User_id.Name || 'User'}
                                                            </Link>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {data.User_id?.Phone && (
                                                            <a
                                                                href={`https://wa.me/${whatsappPhone}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {displayPhone}
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td>{data.Withdraw_type || 'N/A'}</td>
                                                    <td>
                                                        <span className="font-weight-bold text-success" title={withdrawCashbackHint(data) || undefined}>
                                                            ₹{withdrawPayoutAmount(data).toLocaleString("en-IN")}
                                                        </span>
                                                        {hasWithdrawCashback(data) && (
                                                            <div className="small text-muted">{withdrawCashbackHint(data)}</div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <span className="text-truncate d-inline-block" style={{ maxWidth: '140px' }} title={data.User_id?.upi_id || ''}>
                                                                {data.User_id?.upi_id || 'Not set'}
                                                            </span>
                                                            {data.User_id?.upi_id && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-link btn-sm p-0 ml-1"
                                                                    onClick={() => copyToClipboard(data.User_id.upi_id, `upi_${data._id}`)}
                                                                    title="Copy UPI"
                                                                >
                                                                    {copiedUpiId === `upi_${data._id}` ? '✓' : 'Copy'}
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>{getStatusBadge(data.status, data)}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            </>
                        )}

                        {numberOfPages > 1 && (
                            <div className="lp-withdraw-pager mt-3">
                                <ReactPaginate
                                    key={location.search || "all"}
                                    previousLabel="‹"
                                    nextLabel="›"
                                    breakLabel={"..."}
                                    pageCount={numberOfPages}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={"pagination pagination-sm justify-content-center mb-0 flex-nowrap"}
                                    pageClassName={"page-item"}
                                    pageLinkClassName={"page-link border"}
                                    previousClassName={"page-item"}
                                    previousLinkClassName={"page-link border"}
                                    nextClassName={"page-item"}
                                    nextLinkClassName={"page-link border"}
                                    breakClassName={"page-item"}
                                    breakLinkClassName={"page-link border"}
                                    activeClassName={"active"}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Confirmation Modal */}
            {confirmAction.show && (
                <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border" style={{fontSize: '14px'}}>
                            <div className="modal-header border-bottom bg-dark text-white py-2 px-3">
                                <h5 className="modal-title mb-0" style={{fontSize: '16px'}}>Confirm Action</h5>
                                <button 
                                    type="button" 
                                    className="btn-close btn-close-white" 
                                    onClick={resetConfirmModal}
                                ></button>
                            </div>
                            <div className="modal-body bg-light py-3 px-3">
                                <p className="mb-3 text-dark" style={{fontSize: '14px'}}>
                                    Are you sure you want to mark this withdrawal as 
                                    <strong className={confirmAction.type === 'success' ? 'text-success ms-1' : 'text-danger ms-1'}>
                                        {confirmAction.type === 'success' ? 'SUCCESS' : 'FAILED'}
                                    </strong>?
                                </p>
                                {confirmAction.type === 'failed' && (
                                    <WithdrawFailReasonFields
                                        failReason={failReason}
                                        onFailReasonChange={setFailReason}
                                        failNote={failNote}
                                        onFailNoteChange={setFailNote}
                                    />
                                )}
                                {confirmAction.withdraw && (
                                    <div className="border rounded p-3 bg-white">
                                        <div className="row">
                                            <div className="col-12 mb-2">
                                                <small className="text-muted d-block mb-1" style={{fontSize: '12px'}}>Transaction ID</small>
                                                <p className="mb-1 text-dark" style={{fontSize: '13px'}}>
                                                    {confirmAction.withdraw._id}
                                                </p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted d-block mb-1" style={{fontSize: '12px'}}>User</small>
                                                <p className="mb-1 text-dark" style={{fontSize: '13px'}}>{confirmAction.withdraw.User_id?.Name}</p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted d-block mb-1" style={{fontSize: '12px'}}>Pay to user (net)</small>
                                                <p className="mb-0 text-success font-weight-bold" style={{fontSize: '13px'}}>
                                                    ₹{withdrawPayoutAmount(confirmAction.withdraw).toLocaleString("en-IN")}
                                                </p>
                                                {withdrawCashbackHint(confirmAction.withdraw) && (
                                                    <p className="mb-0 small text-muted mt-1">{withdrawCashbackHint(confirmAction.withdraw)}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer border-top py-2 px-3">
                                <button 
                                    type="button" 
                                    className="btn btn-outline-secondary border py-1 px-3" 
                                    onClick={resetConfirmModal}
                                    style={{fontSize: '13px', padding: '8px 20px'}}
                                >
                                    Cancel
                                </button>
                                <button 
                                    type="button" 
                                    className={confirmAction.type === 'success' ? 'btn btn-success border py-1 px-3' : 'btn btn-danger border py-1 px-3'} 
                                    onClick={executeAction}
                                    style={{fontSize: '13px', padding: '8px 20px'}}
                                >
                                    {confirmAction.type === 'success' ? 'Yes, Mark Success' : 'Yes, Mark Failed'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default SucWithdraw; 